import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { candidateRedirect } from "./candidate.guard";

export const teacherGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    router.navigate(["/login"]);
    return false;
  }

  const candidate = candidateRedirect();
  if (candidate) return candidate;

  if (authService.isTeacher()) {
    return true;
  }

  router.navigate(["/home"]);
  return false;
};
